var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7Z",
    fill: "#EFE8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C4.245 2 2 4.245 2 7C2 9.755 4.245 12 7 12C9.755 12 12 9.755 12 7C12 4.245 9.755 2 7 2ZM9.39 5.85L6.555 8.685C6.485 8.755 6.39 8.795 6.29 8.795C6.19 8.795 6.095 8.755 6.025 8.685L4.61 7.27C4.465 7.125 4.465 6.885 4.61 6.74C4.755 6.595 4.995 6.595 5.14 6.74L6.29 7.89L8.86 5.32C9.005 5.175 9.245 5.175 9.39 5.32C9.535 5.465 9.535 5.7 9.39 5.85Z",
    fill: "#851EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleTickCircle);
export default __webpack_public_path__ + "static/media/purple-tick-circle.1d32d6fb5c2fa3683cc5883b3f8b1ada.svg";
export { ForwardRef as ReactComponent };